export default {
  // Page title
  'manualTag.title': 'Manual Tag Management',
  
  // Form fields
  'manualTag.form.tagName': 'Tag Name',
  'manualTag.form.tagNamePlaceholder': 'Please enter tag name',
  'manualTag.form.tagNameRequired': 'Tag name is required',
  'manualTag.form.tagNameMaxLength': 'Tag name cannot exceed 50 characters',
  'manualTag.form.tagDescription': 'Tag Description',
  'manualTag.form.tagDescriptionPlaceholder': 'Please enter tag description (optional, only visible in backend)',
  'manualTag.form.tagDescriptionMaxLength': 'Tag description cannot exceed 255 characters',
  'manualTag.form.currencyScope': 'Applicable Currencies',
  'manualTag.form.currencyPlaceholder': 'Please select applicable currencies',
  'manualTag.form.currencyFilterPlaceholder': 'All currencies',
  'manualTag.form.currencyRequired': 'Select at least one currency',
  
  // Table fields
  'manualTag.table.tagName': 'Tag Name',
  'manualTag.table.currencyScope': 'Applicable Currencies',
  'manualTag.table.tagDescription': 'Description',
  'manualTag.table.hitCount': 'Hit Count',
  'manualTag.table.createTime': 'Create Time',
  'manualTag.table.action': 'Action',
  
  // Action buttons
  'manualTag.action.create': 'Create Tag',
  'manualTag.action.editTags': 'Edit Tags',
  
  // Modal titles
  'manualTag.modal.createTitle': 'Create Tag',
  'manualTag.modal.editTitle': 'Edit Tag',
  'manualTag.modal.editMemberTagTitle': 'Edit Member Tags',
  'manualTag.modal.editHint': 'Click the checkbox to add or remove tags for the member',
  
  // Messages
  'manualTag.message.createSuccess': 'Tag created successfully',
  'manualTag.message.createFailed': 'Failed to create tag',
  'manualTag.message.updateSuccess': 'Update successful',
  'manualTag.message.updateFailed': 'Update failed',
  'manualTag.message.deleteSuccess': 'Tag deleted successfully',
  'manualTag.message.deleteFailed': 'Failed to delete tag',
  'manualTag.message.deleteConfirm': 'Are you sure to delete this tag?',
  'manualTag.message.deleteWarning': 'After deletion, all members with this tag will have it removed',
  
  // Other
  'manualTag.noTags': 'No tags',
  'manualTag.noTagsAvailable': 'No tags available, please create tags in tag management first',
};
